import * as React from 'react';
import { useLeapState } from '../../hooks/useLeapState';
import { useLeapData } from '../../hooks/useLeapData';

import { IComboBox, IComboBoxOption } from '@fluentui/react';

import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';

import Text from '../../components/controls/Text';
import DentalChart from '../../components/controls/dental/DentalChart';
import MultiBox from '../../components/controls/MultiBox';

import { DentalElements } from '../../components/controls/dental/dentalElements';
import SearchBox from '../../components/controls/SearchBox';
import ComboBox from '../../components/controls/ComboBox';
import Option from '../../components/controls/Option';
import { useSecurityRoles } from '../../hooks/useSecurityRoles';
import BodyChart from '../../components/controls/body/BodyChart';
import { BodyElements } from '../../components/controls/body/bodyElements';

type Props = {
    state: any,
    controller: any,
    parentController: any
}

export default (props: Props) => {
    const page = useLeapState(props.controller, false)
    const parentPage = useLeapState(props.parentController, false)    

    const appointmentDate = useLeapData("appointmentDate", "data appuntamento", page)
    const branchID = useLeapData("branchID", "branca", page, "branches")
    const healthServiceID = useLeapData("healthServiceID", "prestazione", page, "healthServices")
    const dentalElement = useLeapData("dentalElement", "elemento dentale", page)
    const anatomicalElement = useLeapData("anatomicalElement", "elemento anatomico", page)

    const amount = useLeapData("amount", "costo", page)
    const freeRate = useLeapData("freeRate", "freeRate", page, "canFreeRate")

    const voucherCode = useLeapData("voucherCode", "codice voucher", page)
    const voucherEndDate = useLeapData("voucherEndDate", "data scadenza voucher ", page)
    const isFemale = useLeapData("isFemale", " ", page)
    const medicalSpecialty = useLeapData("medicalSpecialty", " ", page)
    const fisioSessions = useLeapData("fisioSessions", "nr. sedute", page)
    const therapeuticIndication = useLeapData("therapeuticIndication", "indicazione terapeutica", page, "therapeuticIndication")
    const otherTherapeuticIndication = useLeapData("otherTherapeuticIndication", "altro", page)

    const canFreeRate = page?.item?.state?.lookups?.["canFreeRate"]?.length > 0 ? page.item.state.lookups?.["canFreeRate"][0] : false

    const items: IComboBoxOption[] = DentalElements

    const bodyItems: IComboBoxOption[] = BodyElements

    const filteredBodyItems = !isFemale.value
        ? bodyItems.filter(item => item.key !== '13')
        : bodyItems;


    const selectedTeeth = page.item.values?.dentalElement ? page.item.values.dentalElement.value : (dentalElement ? (dentalElement.value ?? []) : []);

    const selectedPath = page.item.values?.anatomicalElement ? page.item.values.anatomicalElement.value : (anatomicalElement ? (anatomicalElement.value ?? []) : []);

    const isONHC = useSecurityRoles()?.isONHC

    const planType_item: string = parentPage.item?.state?.data?.leap_PlanManagementID;

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <Text {...appointmentDate} type="calendar" className="ms-sm3" />
                        <ComboBox {...branchID} label={medicalSpecialty.value == "1" ? "branca" : "modello riabilitativo"} className="ms-sm9" children={[{ name: "healthServiceID", lookup: "healthServices", controller: props.controller }]} />
                    </Row>
                    <Row>
                        <SearchBox {...healthServiceID} parentController={props.parentController} className={medicalSpecialty.value == "2" ? "ms-sm6" : "ms-sm12"} children={[{ ...freeRate }]} required />
                        <Text {...fisioSessions} className="ms-sm6" type="number" hidden={medicalSpecialty.value != "2"} required={medicalSpecialty.value == "2"} />
                    </Row>
                    <Row>
                        <MultiBox {...dentalElement} className="ms-sm12" options={items} selectedKey={selectedTeeth} children={[{ ...freeRate }]} required={medicalSpecialty.value == "1"} hidden={medicalSpecialty.value != "1"} />
                    </Row>
                    <Row>
                        <MultiBox {...anatomicalElement} className="ms-sm8" options={filteredBodyItems} selectedKey={selectedPath} titleType={"text"} children={[{ ...freeRate }]} required={medicalSpecialty.value == "2"} hidden={medicalSpecialty.value != "2"} />
                        <ComboBox {...therapeuticIndication} className="ms-sm4" hidden={medicalSpecialty.value != "2"} required={medicalSpecialty.value == "2"} />
                    </Row>
                    <Row>
                        <Text {...otherTherapeuticIndication} className="ms-sm12" hidden={page.item.values?.therapeuticIndication?.value != "5"} required={page.item.values?.therapeuticIndication?.value?.key == "5" && medicalSpecialty.value == "2"} />
                    </Row>
                    <Row>
                        <Text {...amount} className="ms-sm2" type="number" hidden={!canFreeRate} required={canFreeRate} />
                    </Row>
                    {isONHC && planType_item === "2" && page.modality === "item" && <>
                        <Row>
                            <Text {...voucherCode} className="ms-sm3" maxlength={100} />
                            <Text {...voucherEndDate} className="ms-sm3" type="calendar" />
                        </Row>
                    </>}
                </Section>
                <Section title="elementi dentali" hidden={medicalSpecialty.value != "1"}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}>
                        <Row>
                            <DentalChart {...dentalElement} parentController={props.parentController} selectionMode="multiple" value={selectedTeeth} children={[{ ...freeRate }]} required={medicalSpecialty.value == "1"} />
                        </Row>
                    </div>
                </Section>
                <Section title="elementi anatomici" hidden={medicalSpecialty.value != "2"}>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column"
                    }}>
                        <Row>
                            <BodyChart {...anatomicalElement} parentController={props.parentController} isFemale={isFemale.value} selectionMode="multiple" value={selectedPath} children={[{ ...freeRate }]} required={medicalSpecialty.value == "2"} />
                        </Row>
                    </div>
                </Section>
            </Grid>
        </>
    );
}